import { FieldPathByValue, FieldValues as FieldValues$, useController, UseControllerProps } from "react-hook-form";
import TextField, { TextFieldProps } from "./TextField";

export type StringFieldName<FieldValues extends FieldValues$> = FieldPathByValue<FieldValues, string>;

export type Props<FieldValues extends FieldValues$, Name extends StringFieldName<FieldValues>> = UseControllerProps<
  FieldValues,
  Name
> &
  TextFieldProps;

export default function ControlledTextField<
  FieldValues extends FieldValues$,
  Name extends StringFieldName<FieldValues>
>({ name, rules, control, required, disabled, ...props }: Props<FieldValues, Name>) {
  const {
    field,
    formState: { isSubmitting },
    fieldState: { error }
  } = useController({ name, rules: { required: !!required, ...rules }, control });

  return (
    <TextField
      {...field}
      value={field.value ?? ""}
      error={!!error}
      errorText={error?.message}
      required={required}
      disabled={isSubmitting || disabled}
      {...props}
    />
  );
}
